import { useNavigate } from "react-router-dom";

export default function SolutionManagementTableColum(props) {
  const solutionManagementColumn = [
    // {
    //   field: 'id',
    //   headerName: 'ID',
    // },
    {
      field: 'solutionName',
      headerName: 'Solution Name',
      flex: 1,
    },
    {
      field: 'ecosystem',
      headerName: 'Ecosystem',
      flex: 1,
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
    },
    {
      field: 'profile',
      headerName: 'Profile',
      flex: 1,
    },

  ];

  return solutionManagementColumn;
}
